import { createViewPrefsStore } from "@ayla/browser-state";

export type ProgressMetrics = {
  talkTime: boolean;
  interruptions: boolean;
  openQuestions: boolean;
  empathy: boolean;
  jargon: boolean;
};

export type ViewPrefs = {
  showTalkTime: boolean;
  showQuestionMix: boolean;
  showTranscriptTags: boolean;
  showCoachNotes: boolean;
  showInterruptions: boolean;
  showEmpathy: boolean;
  progressMetrics: ProgressMetrics;
};

export const DEFAULT_PROGRESS_METRICS: ProgressMetrics = {
  talkTime: true,
  interruptions: true,
  openQuestions: true,
  empathy: true,
  jargon: false,
};

const defaults: ViewPrefs = {
  showTalkTime: true,
  showQuestionMix: true,
  showTranscriptTags: true,
  showCoachNotes: true,
  showInterruptions: true,
  showEmpathy: true,
  progressMetrics: DEFAULT_PROGRESS_METRICS,
};

export const { KEY, EVT, DEFAULT_PREFS, loadViewPrefs, saveViewPrefs } =
  createViewPrefsStore<ViewPrefs>({
    key: "engage:viewPrefs:v1",
    event: "engage:viewPrefs:changed",
    defaults,
    legacyKeys: ["stetho:viewPrefs:v1"],
  });
